<template>
  <div>
    <div>Booking No.</div>
    <h2>{{ bookingInfo.bookingNo }}</h2>
    <v-card>
      <div class="px-5 pt-5 pb-5">
        <h3>Training Course</h3>
        <div>{{ `${bookingInfo.course.courseCode} ${bookingInfo.course.courseName}` }}</div>
        <div>{{ fullName }}</div>
        <div>{{ bookingInfo.center.description }}</div>
        <div>{{ courseDate }}</div>
        <div>{{ courseTime }}</div>
      </div>
    </v-card>
  </div>
</template>
<script setup>
import { ref, computed, toRefs } from 'vue'
import moment from '@/utils/moment'
import { formatDate, formatTime } from '@/utils/helper'

const props = defineProps({
  bookingInfo: {
    type: Object,
    default() {
      return {
        bookingNo: 'BAM2200001',
        course: {
          courseCode: 'C001',
          courseName: 'WT',
        },
        userRecord: {
          fullName: 'Paul Chan',
        },
        center: {
          description: 'Mong Kok',
        },
        courseDate: '2023-02-16',
        courseStartTime: '2023-02-16T01:00:00.000Z',
        courseEndTime: '2023-02-16T02:00:00.000Z',
      }
    },
  },
})
const { bookingInfo } = toRefs(props)

const fullName = computed(() => {
  if (bookingInfo.value.userRecord) {
    return bookingInfo.value.userRecord.fullName
  }

  return 'Full name not found'
})

const courseDate = computed(() => {
  if (bookingInfo.value.courseDate) {
    return formatDate(bookingInfo.value.courseDate)
  }

  return 'Course date not found'
})
const courseTime = computed(() => {
  if (bookingInfo.value.courseStartTime) {
    return `${formatTime(bookingInfo.value.courseStartTime)} ~ ${formatTime(bookingInfo.value.courseEndTime)}`
  }

  return 'Course start time not found'
})
</script>
